import "./case-studies.scss";
import MarketingPage from "../marketing-page";
import { Link } from "react-router-dom";

const CaseStudy = ({ logError }) => {
    return (
        <MarketingPage
            logError={logError}>
            <h1 className="">
                Case Studies
            </h1>
            <div className="case-studies-container">
                <Link className="no-highlight" to={"/case-studies/enhancing-indie-film-production-with-filmanize"}>
                    <img className="case-study-image" src="/images/case-studies/ppaulm-112f_2023-05-15-08-26-48.jpg"></img>
                    <div className="case-study-name">Paul Mailath, Producer/Director/DoP/Soundie/Gaffer</div>
                    <h3>Enhancing Indie Film Production with Filmanize</h3>
                </Link>
            </div>
        </MarketingPage>
    );
}

export default CaseStudy;